// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"header-fragment__Breadcrumbs_breadcrumbs__PfdNX"};